<template>
  <div id="app">
    <TopBar/>
    <router-view/>
    <Footer v-if="isRouterAlive" v/>
  </div>
</template>
<script>
  import TopBar from "./components/TopBar";
  import Footer from "./components/Footer";
  export default {
    components:{TopBar,Footer},
    data(){
      return {
        isRouterAlive:true,
      }
    },
    //监听器
    watch: {
      // 方法1
      '$route': { //监听路由是否变化
        handler:function(val, oldVal){
          this.isRouterAlive = false
          this.$nextTick(function(){  //页面加载完成后执行
            var that = this;
            setTimeout(()=>{
              that.reload()
            },200)
          })
        },
        // 深度观察监听
        deep: true
      },
    },
    mounted() {
      console.log('document.referrer',document.referrer);
      if(document.referrer){
        this.getSearchKeywordFromGoogle(document.referrer)
      }
    },
    methods:{
      getSearchKeywordFromGoogle(url) {
        var params = new URL(url).searchParams;
        console.log('new URL(url)', new URL(url));
        console.log('params', params);
        return params.get('q');
      },
      reload(){
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true
        });
      },
    },
  };
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  outline: 0;
  -webkit-text-size-adjust: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-appearance: none;
  /*消除输入框和按钮的原生外观*/
  font-family: "\5FAE\8F6F\96C5\9ED1";
}

</style>
